module.exports = __webpack_public_path__ + "img/skip-end-btn.2b3103f5.svg";